var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBottomLeft = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40039 8.03127L2.40039 20.7679C2.40039 21.227 2.77298 21.5996 3.23206 21.5996L15.9687 21.5996C16.4278 21.5996 16.8004 21.227 16.8004 20.7679C16.8004 20.3089 16.4278 19.9363 15.9687 19.9363L4.06372 19.9363L4.06372 8.03127C4.06372 7.57219 3.69113 7.19961 3.23205 7.19961C2.77298 7.19961 2.40039 7.5722 2.40039 8.03127Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5183 14.7532L19.6868 5.58463C20.0383 5.23316 20.0383 4.66331 19.6868 4.31184C19.3354 3.96037 18.7655 3.96037 18.414 4.31184L9.24547 13.4804L7.33628 11.5712L7.34265 16.656L12.4275 16.6624L10.5183 14.7532Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBottomLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bottom-left.0e237b5c.svg";
export { ForwardRef as ReactComponent };